import { validateNameDescriptionRow } from "../../../../utils/validate-name-description-row";
import { RoomlayoutServiceRowValues } from "../Domain/Types/FacilityService-Roomlayout-row.types";

export function validateRoomlayoutRow(row: Partial<RoomlayoutServiceRowValues>) {
  return validateNameDescriptionRow(row);
}
